import React from "react";
import { Helmet } from "react-helmet";
import Layout from "./Layout";
import QRLinks from "./QRLinks";
import UrlQR from "./UrlQR";
import BottomContent from "./BottomContent";

function Home() {
  return (
    <Layout>
      <Helmet>
        <title>
          QR Code Generator :: Create Free QR Codes - Instant QR Codes
        </title>
        <met
          name="description"
          content="Free QR Code Generator. Create QR codes for websites, whatsapp, UPI, vCard, and many more. Download the generated qr code for free &amp; instantly."
        />
        <link rel="canonical" href="https://instantqrcodes.com" />
      </Helmet>
      <QRLinks />
      <UrlQR />
      <BottomContent />
    </Layout>
  );
}

export default Home;
